<template>
  <div class="portal-layout">
    <PortalSidebarWrapper v-model="sidebarOpen" />
    <main class="main-content">
      <transition name="component-fade" mode="out-in">
        <router-view />
      </transition>
    </main>
  </div>
</template>

<script>
import PortalSidebarWrapper from '@/components/portal/PortalSidebarWrapper.vue'

export default {
  name: 'PortalLayout',
  components: {
    PortalSidebarWrapper,
  },
  data() {
    return {
      sidebarOpen: false,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/light-theme-system-palette.scss';
@import '@/assets/css/vuetify3Breakpoints.scss';

.portal-layout {
  background-color: $surface;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}
.main-content {
  flex: 1;
  width: 100%;
  padding: 0;
  overflow-y: auto;

  @include breakpoint(md) {
    padding: 24px;
  }
}

@include breakpoint(md) {
  .portal-layout {
    flex-direction: row;
  }

  .main-content {
    padding: 24px;
  }
}

::v-deep .vap-page {
  border-radius: 0;
  @include breakpoint(md) {
    border-radius: 16px;
  }
}
</style>
